import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

/**
 * The function `InvestorIpoSaleFilter` is a React component that renders a filter for selecting
 * investor sale options in an IPO.
 * @returns a JSX element, which represents a section of a user interface.
 */
function InvestorIpoSaleFilter({ InvestorSaleOptions, setInvestorSaleOptions, customPathname, defaultLabel = "Select", isPopupOpen, setIsPopupOpen }) {
    const { InvestorSaleIPO, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.investorSaleInipo?.map(value => value.value) ?? [];
        setInvestorSaleOptions(InvestorSaleIPO?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.value) })))
    }, [InvestorSaleIPO, customPathname, refineSearchFilters, setInvestorSaleOptions])


    const handleInvestorTypeChange = (e) => {
        const value = e.target.value
        setInvestorSaleOptions(InvestorSaleOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.value === value })))
    };

    const selected = InvestorSaleOptions?.filter(option => option.isChecked)?.at(0)

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">Investor Sale in IPO?</span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                            Investor Sale in IPO?
                        </label> */}
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto grid grid-cols-3">
                                {!selected && (
                                    <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                        <input
                                            type="radio"
                                            name="investorIpoSale"
                                            value=""
                                            checked={!selected}
                                            onChange={handleInvestorTypeChange}
                                            className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                        />
                                        <span className="text-[13px] font-semibold">Select</span>
                                    </label>
                                )}
                                {InvestorSaleOptions && InvestorSaleOptions.length > 0 && 
                                    InvestorSaleOptions
                                        .filter(investorIpo => investorIpo.name !== "Select" && investorIpo.name !== "select")
                                        .map((investorIpo) => (
                                            <label key={investorIpo.value} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="investorIpoSale"
                                                    value={investorIpo.value}
                                                    checked={selected?.value === investorIpo.value}
                                                    onChange={handleInvestorTypeChange}
                                                    className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                                />
                                                <span className="text-[13px] font-semibold">{investorIpo.name}</span>
                                            </label>
                                        ))
                                }
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default InvestorIpoSaleFilter